module.exports = __webpack_public_path__ + "img/lixiang.c3946f96.png";